import { render, staticRenderFns } from "./SubmitDeclarationsModal.vue?vue&type=template&id=f34fc436&scoped=true&"
import script from "./SubmitDeclarationsModal.vue?vue&type=script&lang=js&"
export * from "./SubmitDeclarationsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f34fc436",
  null
  
)

export default component.exports